import { Typography } from '@mui/material';
import { styled } from '@mui/styles';

export const BoxedTypography = styled(Typography)(({ theme }) => ({
  width: 'fit-content',
  color: theme.palette.grey[500],
  borderRadius: '4px',
  border: '1px solid #bdc4cb',
  padding: '8px',
  // to make it look like code
  fontFamily: 'Monaco, monospace',
  fontSize: '0.9em',
}));
